export const BANNER_NAME = 'BANNER_NAME_AUTO_UPGRADE_NOT_A_TRIAL';
export const BANNER_HEIGHT = 44;
export const EXPERIMENT_KEY = 'auto_upgrade_not_a_trial_experiment';
export const ERROR_BOUNDARY_KEY = 'auto-upgrade-not-a-trial-error-boundary';
export const STANDARD_TRIAL_DAYS_TO_DEACTIVATION = 14;
